module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "mousedown": _vm.handleMouseDown,
      "mouseup": function($event) {
        return _vm.end()
      },
      "mouseleave": function($event) {
        return _vm.end()
      },
      "touchstart": _vm.handleTouchStart,
      "touchend": function($event) {
        return _vm.end()
      },
      "touchcancel": function($event) {
        return _vm.end()
      }
    }
  }, [_c('div', {
    ref: "holder",
    staticClass: "mu-ripple-wrapper",
    class: _vm.rippleWrapperClass
  }, _vm._l((_vm.ripples), function(ripple) {
    return _c('circle-ripple', {
      key: ripple.key,
      attrs: {
        "color": ripple.color,
        "opacity": ripple.opacity,
        "merge-style": ripple.style
      }
    })
  }), 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7236d8ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/internal/touchRipple.vue
// module id = 3776
// module chunks = 1